import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type GameItem = paths['/v4/game/{slug}/'];

const getGameItem = createRequest<GameItem>('/pc/v4/game/{slug}');

export default getGameItem;
